import { render, staticRenderFns } from "./ExtendsForm.vue?vue&type=template&id=bb9a1d9a&"
import script from "./ExtendsForm.vue?vue&type=script&lang=ts&"
export * from "./ExtendsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports